import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBarComponent } from './info-bar.component';

export { InfoBarComponent };

@NgModule({
  imports: [CommonModule],
  declarations: [InfoBarComponent],
  exports: [InfoBarComponent],
})
export class InfoBarModule {}
